import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    const exchange = async () => {
      try {
        const res = await fetch(`${API}/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!res.ok) throw new Error("session exchange failed");
        const user = await res.json();
        navigate("/admin", { state: { user }, replace: true });
      } catch {
        navigate("/admin", { replace: true });
      }
    };
    exchange();
  }, [location, navigate]);

  return (
    <div data-testid="auth-callback" className="min-h-[60vh] flex items-center justify-center">
      <img src="/logo.png" alt="Redeemer Solutions" className="h-16 w-auto" />
    </div>
  );
}
